const legalTemplateTranslations = {
  en: {
    navigation: "Legal templates",
    back: "Back",
    title: "Approved Legal Template Registry",
    subtitle: "Lawyer-controlled wording, immutable approvals and traceable template provenance.",
    total: "Total templates",
    draft: "Draft",
    approved: "Approved",
    retired: "Retired",
    allStatuses: "All statuses",
    noTemplates: "No legal templates found.",
    selectDocx: "Select a DOCX template",
    upload: "Upload controlled template",
    uploadNotice: "Only externally approved wording may be uploaded. Approval locks the source file and its SHA-256 record.",
    uploaded: "Template uploaded",
    actionFailed: "Action failed",
    cancel: "Cancel",
    approveTitle: "Approve legal template",
    confirmApproval: "I confirm that the exact uploaded wording has been reviewed and approved by a qualified legal professional.",
    recordApproval: "Approve and lock template",
    download: "Download source",
    approve: "Review and approve",
    retire: "Retire",
    retireConfirm: "Retire this template? Existing generated records remain unchanged.",
    version: "Version",
    language: "Language",
    source: "Source",
    fields: {
      title: "Template title",
      documentType: "Document type",
      legalFramework: "Legal framework",
      language: "Document language",
      controllingLanguage: "Controlling language",
      source: "Template source",
      version: "Template version",
      governingLaw: "Governing law",
      jurisdiction: "Jurisdiction",
      licenseReference: "Licence reference",
      lawyerNotes: "Lawyer/source notes",
      file: "Approved wording template (DOCX)",
    },
  },
  pt: {
    navigation: "Modelos jurídicos",
    back: "Voltar",
    title: "Registo de Modelos Jurídicos Aprovados",
    subtitle: "Redação controlada por juristas, aprovações imutáveis e proveniência rastreável.",
    total: "Total de modelos",
    draft: "Rascunho",
    approved: "Aprovado",
    retired: "Retirado",
    allStatuses: "Todos os estados",
    noTemplates: "Não foram encontrados modelos jurídicos.",
    selectDocx: "Selecionar modelo DOCX",
    upload: "Carregar modelo controlado",
    uploadNotice: "Apenas pode ser carregada redação aprovada externamente. A aprovação bloqueia o ficheiro de origem e o respetivo registo SHA-256.",
    uploaded: "Modelo carregado",
    actionFailed: "A ação falhou",
    cancel: "Cancelar",
    approveTitle: "Aprovar modelo jurídico",
    confirmApproval: "Confirmo que a redação exata carregada foi revista e aprovada por um profissional jurídico qualificado.",
    recordApproval: "Aprovar e bloquear modelo",
    download: "Descarregar original",
    approve: "Rever e aprovar",
    retire: "Retirar",
    retireConfirm: "Retirar este modelo? Os registos já gerados permanecerão inalterados.",
    version: "Versão",
    language: "Idioma",
    source: "Origem",
    fields: {
      title: "Título do modelo",
      documentType: "Tipo de documento",
      legalFramework: "Enquadramento jurídico",
      language: "Idioma do documento",
      controllingLanguage: "Idioma prevalecente",
      source: "Origem do modelo",
      version: "Versão do modelo",
      governingLaw: "Lei aplicável",
      jurisdiction: "Jurisdição",
      licenseReference: "Referência da licença",
      lawyerNotes: "Notas do jurista/origem",
      file: "Modelo com redação aprovada (DOCX)",
    },
  },
  zh: {
    navigation: "法律模板",
    back: "返回",
    title: "已批准法律模板登记册",
    subtitle: "律师控制的条款、不可变审批及可追溯的模板来源。",
    total: "模板总数",
    draft: "草稿",
    approved: "已批准",
    retired: "已停用",
    allStatuses: "所有状态",
    noTemplates: "未找到法律模板。",
    selectDocx: "选择 DOCX 模板",
    upload: "上传受控模板",
    uploadNotice: "仅可上传经外部批准的准确条款。批准后将锁定源文件及其 SHA-256 记录。",
    uploaded: "模板已上传",
    actionFailed: "操作失败",
    cancel: "取消",
    approveTitle: "批准法律模板",
    confirmApproval: "我确认所上传的准确条款已由合格法律专业人士审核并批准。",
    recordApproval: "批准并锁定模板",
    download: "下载源文件",
    approve: "审核并批准",
    retire: "停用",
    retireConfirm: "停用此模板？现有生成记录将保持不变。",
    version: "版本",
    language: "语言",
    source: "来源",
    fields: {
      title: "模板标题", documentType: "文件类型",
      legalFramework: "法律框架", language: "文件语言",
      controllingLanguage: "主导语言", source: "模板来源",
      version: "模板版本", governingLaw: "适用法律",
      jurisdiction: "管辖权", licenseReference: "许可编号",
      lawyerNotes: "律师/来源说明", file: "已批准条款模板（DOCX）",
    },
  },
  fr: {
    navigation: "Modèles juridiques",
    back: "Retour",
    title: "Registre des Modèles Juridiques Approuvés",
    subtitle: "Rédaction contrôlée par des juristes, approbations immuables et provenance traçable.",
    total: "Total des modèles",
    draft: "Brouillon",
    approved: "Approuvé",
    retired: "Retiré",
    allStatuses: "Tous les statuts",
    noTemplates: "Aucun modèle juridique trouvé.",
    selectDocx: "Sélectionner un modèle DOCX",
    upload: "Téléverser un modèle contrôlé",
    uploadNotice: "Seul un texte approuvé extérieurement peut être téléversé. L’approbation verrouille le fichier source et son empreinte SHA-256.",
    uploaded: "Modèle téléversé",
    actionFailed: "Échec de l’action",
    cancel: "Annuler",
    approveTitle: "Approuver le modèle juridique",
    confirmApproval: "Je confirme que le texte exact téléversé a été révisé et approuvé par un professionnel juridique qualifié.",
    recordApproval: "Approuver et verrouiller",
    download: "Télécharger la source",
    approve: "Réviser et approuver",
    retire: "Retirer",
    retireConfirm: "Retirer ce modèle ? Les documents déjà générés resteront inchangés.",
    version: "Version",
    language: "Langue",
    source: "Source",
    fields: {
      title: "Titre du modèle", documentType: "Type de document",
      legalFramework: "Cadre juridique", language: "Langue du document",
      controllingLanguage: "Langue faisant foi", source: "Source du modèle",
      version: "Version du modèle", governingLaw: "Droit applicable",
      jurisdiction: "Juridiction", licenseReference: "Référence de licence",
      lawyerNotes: "Notes du juriste/de la source", file: "Modèle au texte approuvé (DOCX)",
    },
  },
  es: {
    navigation: "Plantillas jurídicas",
    back: "Volver",
    title: "Registro de Plantillas Jurídicas Aprobadas",
    subtitle: "Redacción controlada por juristas, aprobaciones inmutables y procedencia trazable.",
    total: "Total de plantillas",
    draft: "Borrador",
    approved: "Aprobado",
    retired: "Retirada",
    allStatuses: "Todos los estados",
    noTemplates: "No se encontraron plantillas jurídicas.",
    selectDocx: "Seleccionar plantilla DOCX",
    upload: "Cargar plantilla controlada",
    uploadNotice: "Solo puede cargarse redacción aprobada externamente. La aprobación bloquea el archivo fuente y su registro SHA-256.",
    uploaded: "Plantilla cargada",
    actionFailed: "La acción ha fallado",
    cancel: "Cancelar",
    approveTitle: "Aprobar plantilla jurídica",
    confirmApproval: "Confirmo que la redacción exacta cargada fue revisada y aprobada por un profesional jurídico cualificado.",
    recordApproval: "Aprobar y bloquear plantilla",
    download: "Descargar fuente",
    approve: "Revisar y aprobar",
    retire: "Retirar",
    retireConfirm: "¿Retirar esta plantilla? Los registros ya generados no se modificarán.",
    version: "Versión",
    language: "Idioma",
    source: "Origen",
    fields: {
      title: "Título de la plantilla", documentType: "Tipo de documento",
      legalFramework: "Marco jurídico", language: "Idioma del documento",
      controllingLanguage: "Idioma prevalente", source: "Origen de la plantilla",
      version: "Versión de la plantilla", governingLaw: "Ley aplicable",
      jurisdiction: "Jurisdicción", licenseReference: "Referencia de licencia",
      lawyerNotes: "Notas del jurista/origen", file: "Plantilla con redacción aprobada (DOCX)",
    },
  },
  de: {
    navigation: "Rechtsvorlagen",
    back: "Zurück",
    title: "Register Genehmigter Rechtsvorlagen",
    subtitle: "Juristisch kontrollierter Wortlaut, unveränderliche Freigaben und nachvollziehbare Herkunft.",
    total: "Vorlagen insgesamt",
    draft: "Entwurf",
    approved: "Genehmigt",
    retired: "Stillgelegt",
    allStatuses: "Alle Status",
    noTemplates: "Keine Rechtsvorlagen gefunden.",
    selectDocx: "DOCX-Vorlage auswählen",
    upload: "Kontrollierte Vorlage hochladen",
    uploadNotice: "Es darf nur extern genehmigter Wortlaut hochgeladen werden. Die Freigabe sperrt die Quelldatei und ihren SHA-256-Datensatz.",
    uploaded: "Vorlage hochgeladen",
    actionFailed: "Aktion fehlgeschlagen",
    cancel: "Abbrechen",
    approveTitle: "Rechtsvorlage genehmigen",
    confirmApproval: "Ich bestätige, dass der genaue hochgeladene Wortlaut von einer qualifizierten juristischen Fachperson geprüft und genehmigt wurde.",
    recordApproval: "Genehmigen und sperren",
    download: "Quelldatei herunterladen",
    approve: "Prüfen und genehmigen",
    retire: "Stilllegen",
    retireConfirm: "Diese Vorlage stilllegen? Bestehende generierte Datensätze bleiben unverändert.",
    version: "Version",
    language: "Sprache",
    source: "Quelle",
    fields: {
      title: "Vorlagentitel", documentType: "Dokumenttyp",
      legalFramework: "Rechtsrahmen", language: "Dokumentsprache",
      controllingLanguage: "Maßgebende Sprache", source: "Vorlagenquelle",
      version: "Vorlagenversion", governingLaw: "Anwendbares Recht",
      jurisdiction: "Gerichtsstand", licenseReference: "Lizenzreferenz",
      lawyerNotes: "Anmerkungen des Juristen/der Quelle", file: "Vorlage mit genehmigtem Wortlaut (DOCX)",
    },
  },
  it: {
    navigation: "Modelli legali",
    back: "Indietro",
    title: "Registro dei Modelli Legali Approvati",
    subtitle: "Testo controllato da legali, approvazioni immutabili e provenienza tracciabile.",
    total: "Totale modelli",
    draft: "Bozza",
    approved: "Approvato",
    retired: "Ritirato",
    allStatuses: "Tutti gli stati",
    noTemplates: "Nessun modello legale trovato.",
    selectDocx: "Seleziona modello DOCX",
    upload: "Carica modello controllato",
    uploadNotice: "È consentito caricare solo testo approvato esternamente. L’approvazione blocca il file sorgente e il relativo record SHA-256.",
    uploaded: "Modello caricato",
    actionFailed: "Azione non riuscita",
    cancel: "Annulla",
    approveTitle: "Approva modello legale",
    confirmApproval: "Confermo che il testo esatto caricato è stato esaminato e approvato da un professionista legale qualificato.",
    recordApproval: "Approva e blocca modello",
    download: "Scarica sorgente",
    approve: "Esamina e approva",
    retire: "Ritira",
    retireConfirm: "Ritirare questo modello? I documenti già generati resteranno invariati.",
    version: "Versione",
    language: "Lingua",
    source: "Origine",
    fields: {
      title: "Titolo del modello", documentType: "Tipo di documento",
      legalFramework: "Quadro giuridico", language: "Lingua del documento",
      controllingLanguage: "Lingua prevalente", source: "Origine del modello",
      version: "Versione del modello", governingLaw: "Legge applicabile",
      jurisdiction: "Giurisdizione", licenseReference: "Riferimento licenza",
      lawyerNotes: "Note del legale/della fonte", file: "Modello con testo approvato (DOCX)",
    },
  },
  ru: {
    navigation: "Юридические шаблоны",
    back: "Назад",
    title: "Реестр Утверждённых Юридических Шаблонов",
    subtitle: "Контролируемые юристами формулировки, неизменяемые согласования и отслеживаемое происхождение.",
    total: "Всего шаблонов",
    draft: "Черновик",
    approved: "Утверждён",
    retired: "Выведен",
    allStatuses: "Все статусы",
    noTemplates: "Юридические шаблоны не найдены.",
    selectDocx: "Выбрать шаблон DOCX",
    upload: "Загрузить контролируемый шаблон",
    uploadNotice: "Допускается загрузка только формулировок, утверждённых внешним юристом. После утверждения исходный файл и его запись SHA-256 блокируются.",
    uploaded: "Шаблон загружен",
    actionFailed: "Не удалось выполнить действие",
    cancel: "Отмена",
    approveTitle: "Утвердить юридический шаблон",
    confirmApproval: "Я подтверждаю, что точный текст загруженного документа проверен и утверждён квалифицированным юристом.",
    recordApproval: "Утвердить и заблокировать",
    download: "Скачать исходник",
    approve: "Проверить и утвердить",
    retire: "Вывести",
    retireConfirm: "Вывести этот шаблон? Ранее созданные записи останутся без изменений.",
    version: "Версия",
    language: "Язык",
    source: "Источник",
    fields: {
      title: "Название шаблона", documentType: "Тип документа",
      legalFramework: "Правовая основа", language: "Язык документа",
      controllingLanguage: "Преимущественный язык", source: "Источник шаблона",
      version: "Версия шаблона", governingLaw: "Применимое право",
      jurisdiction: "Юрисдикция", licenseReference: "Ссылка на лицензию",
      lawyerNotes: "Примечания юриста/источника", file: "Шаблон с утверждённым текстом (DOCX)",
    },
  },
};

export default legalTemplateTranslations;
